import Bar from '@rio-cloud/rio-uikit/Bar';
import BarChart from '@rio-cloud/rio-uikit/BarChart';
import ChartTooltip from '@rio-cloud/rio-uikit/ChartTooltip';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ChartTooltipContent } from '@/features/dashboard/components/ChartTooltipContent';
import type { EnergyChartProps } from '@/features/dashboard/types';
import { transformToChartData } from '@/features/dashboard/utils';
import { formatCurrencyValue, formatDateLocalized } from '@/lib/utils';
import { useUserStore } from '@/stores/userStore';

export const EnergyChart = ({ sessions, timeFrame }: EnergyChartProps) => {
    const { currency } = useUserStore();
    const { locale } = useIntl();
    const chartData = useMemo(() => transformToChartData(sessions.chargingActivitySummaryList), [sessions]);

    const formatAxisValue = (value: number) => formatCurrencyValue(value, currency, locale, 0).value;
    const xAxisDateFormat = sessions.clusteredBy === 'DAY' ? 'dd MMM yy' : 'MMM yy';
    const tooltipDateFormat = sessions.clusteredBy === 'DAY' ? 'dd MMM yyyy' : 'MMMM yyyy';
    const formatDateTick = (value: string) => formatDateLocalized(new Date(value), locale, false, xAxisDateFormat);

    return (
        <div className='width-100pct padding-x-20'>
            <BarChart
                data={chartData}
                dataKey='date'
                yAxisOptions={{ tickFormatter: formatAxisValue }}
                xAxisOptions={{
                    dataKey: 'date',
                    tickFormatter: formatDateTick,
                    padding: { left: 30, right: 30 },
                }}
                tooltip={
                    <ChartTooltip
                        wrapperStyle={{ outline: 'none' }}
                        cursor={{ fill: 'var(--gray-lightest)' }}
                        content={
                            <ChartTooltipContent
                                dateFormat={tooltipDateFormat}
                                timeFrame={timeFrame}
                                isClusteredByMonth={sessions.clusteredBy === 'MONTH'}
                            />
                        }
                    />
                }
                bars={[<Bar key='costs' dataKey='costs' />]}
            />
        </div>
    );
};
